import React, { useState, useEffect } from 'react';
import apiClient from '../api';
import '../styles/github.css';
import ParticlesBackground from './ParticlesBackground';
import LoginModal from './LoginModal';
import MemoLogo from './MemoLogo';

function Login({ setToken }) {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    const savedTheme = localStorage.getItem('memo_theme') || 'dark';
    setTheme(savedTheme);
    document.body.classList.add(savedTheme + '-theme');
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('memo_theme', newTheme);
    
    document.body.classList.remove(theme + '-theme');
    document.body.classList.add(newTheme + '-theme');
  };

  const handleLoginSuccess = (token, user) => {
    localStorage.setItem('memo_token', token);
    localStorage.setItem('memo_user', JSON.stringify(user));
    setToken(token);
    if (window.location.pathname !== '/') {
      window.location.href = '/';
    }
  };

  return (
    <div style={styles.pageContainer}>
      <div className={`dynamic-bg ${theme}-theme`} />
      <ParticlesBackground theme={theme} />
      
      <div className="theme-toggle" onClick={toggleTheme} style={styles.themeToggle}>
        {theme === 'dark' ? (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#f5f0e6">
            <path d="M9.37 5.51c-.18.64-.27 1.31-.27 1.99 0 4.08 3.32 7.4 7.4 7.4.68 0 1.35-.09 1.99-.27C17.45 17.19 14.93 19 12 19c-3.86 0-7-3.14-7-7 0-2.93 1.81-5.45 4.37-6.49zM12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-.46-.04-.92-.1-1.36-.98 1.37-2.58 2.26-4.4 2.26-2.98 0-5.4-2.42-5.4-5.4 0-1.81.89-3.42 2.26-4.4-.44-.06-.9-.1-1.36-.1z"/>
          </svg>
        ) : (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#f9c796a4">
            <path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .39-.39.39-1.03 0-1.41L5.99 4.58zm12.37 12.37c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .39-.39.39-1.03 0-1.41l-1.06-1.06zm1.06-10.96c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41.39.39 1.03.39 1.41 0l1.06-1.06zM7.05 18.36c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41.39.39 1.03.39 1.41 0l1.06-1.06z"/>
          </svg>
        )}
      </div>

      <header style={styles.header}>
        <div className="container" style={styles.headerContainer}>
          <div style={styles.logo}>
            <MemoLogo size={32} />
            <span style={styles.logoText}>MemoHub</span>
          </div>
          <div style={styles.headerLinks}>
            <a href="/" style={styles.headerLink}>首页</a>
            <button 
              onClick={() => setShowLoginModal(true)} 
              className="btn btn-primary"
              style={styles.loginButton}
            >
              登录
            </button>
            <a href="/register" className="btn btn-outline register-button" style={styles.registerButton}>
              注册
            </a>
          </div>
        </div>
      </header>

      <main style={styles.main}>
        <div className="container" style={styles.container}>
          <div style={styles.heroSection}>
            <div 
              className="card floating-card" 
              style={styles.heroCard}
            >
              <h1 style={styles.heroTitle}>
                <span style={styles.gradientText}>MemoHub</span>
              </h1>
              <p style={styles.heroSubtitle}>
                管理你的知识，记录每一次思考的提交
              </p>
              <div style={styles.heroButtons}>
                <button 
                  onClick={() => setShowLoginModal(true)} 
                  className="btn btn-primary"
                  style={styles.ctaButton}
                >
                  <svg style={{marginRight: '8px'}} width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                    <path fillRule="evenodd" d="M7.75 2a.75.75 0 01.75.75V7h4.25a.75.75 0 110 1.5H8.5v4.25a.75.75 0 11-1.5 0V8.5H2.75a.75.75 0 010-1.5H7V2.75A.75.75 0 017.75 2z"/>
                  </svg>
                  立即登录
                </button>
                <a href="/register" className="btn btn-outline" style={styles.secondaryButton}>
                  <MemoLogo 
                    size={24} 
                    style={{ marginRight: '8px' }}
                  />
                  创建账户
                </a>
              </div>
            </div>
          </div>

          <div style={styles.featuresGrid}>
            {features.map((feature, index) => (
              <div 
                key={index} 
                className="card floating-card" 
                style={{...styles.featureCard, animationDelay: `${index * 0.1}s`}}
              >
                <div style={styles.featureIcon}>{feature.icon}</div>
                <h3 style={styles.featureTitle}>{feature.title}</h3>
                <p style={styles.featureDescription}>{feature.description}</p>
              </div>
            ))}
          </div>

          <div style={styles.codeSection}>
            <div className="card" style={styles.codeCard}>
              <div style={styles.codeHeader}>
                <div style={styles.codeTitle}>像提交代码一样记录想法</div>
                <div style={styles.codeTabs}>
                  <span style={styles.codeTabActive}>memo.md</span>
                  <span style={styles.codeTab}>commit.json</span>
                </div>
              </div>
              <pre style={styles.codeBlock}>
                <code>
{`# 今日思考

## 📝 项目计划
- [x] 设计登录界面
- [ ] 实现动态背景
- [ ] 添加主题切换

## 💡 灵感记录
function createMemo(title, content) {
  return {
    id: generateId(),
    title: title,
    content: content,
    createdAt: new Date(),
    tags: ['想法', '计划']
  };
}`}
                </code>
              </pre>
            </div>
          </div>
        </div>
      </main>

      <footer style={styles.footer}>
        <div className="container" style={styles.footerContainer}>
          <div style={styles.footerContent}>
            <div style={styles.footerLogo}>
              <MemoLogo size={24} theme="dark" />
              <span style={{marginLeft: '8px', fontWeight: '600', color: 'var(--color-header-text)'}}>MemoHub</span>
            </div>
            <div style={styles.footerLinks}>
              <a href="/terms" style={styles.footerLink}>服务</a>
              <a href="/privacy" style={styles.footerLink}>隐私</a>
              <a href="#" style={styles.footerLink}>社区</a>
              <a href="#" style={styles.footerLink}>关于</a>
            </div>
            <div style={styles.footerCopyright}>
              © {new Date().getFullYear()} MemoHub.为思考而生。
              <div style={{ marginTop: '8px', fontSize: '12px', opacity: 0.7 }}>
                <a 
                  href="https://beian.miit.gov.cn/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ color: 'var(--color-header-text)', textDecoration: 'none' }}
                >
                  蜀ICP备202517670号
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {showLoginModal && (
        <div className="modal-overlay" onClick={() => setShowLoginModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={styles.modal}>
            <LoginModal
              onClose={() => setShowLoginModal(false)}
              onLoginSuccess={handleLoginSuccess}
              theme={theme}
            />
          </div>
        </div>
      )}
    </div>
  );
}

const features = [
  {
    icon: '📚',
    title: '知识仓库',
    description: '管理你的知识库，每个笔记都是一个commit'
  },
  {
    icon: '🔍',
    title: '智能搜索',
    description: '快速找到你需要的信息，支持代码片段搜索'
  },
  {
    icon: '🎨',
    title: '主题定制',
    description: '支持暗色/明色主题，保护你的眼睛'
  },
  {
    icon: '⚡',
    title: '实时同步',
    description: '跨设备实时同步，随时随地访问你的笔记'
  }
];

const styles = {
  pageContainer: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  header: {
    padding: '24px 0',
    position: 'relative',
    zIndex: 10,
    backgroundColor: 'var(--color-header-bg)',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '1280px',
    margin: '0 auto',
    padding: '0 24px',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  logoText: {
    fontSize: '24px',
    fontWeight: '700',
    background: 'linear-gradient(135deg, #58a6ff 0%, #1f6feb 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },
  headerLinks: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  headerLink: {
    color: 'var(--color-header-text)',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: '500',
    padding: '8px 12px',
    borderRadius: '6px',
    transition: 'all 0.2s ease',
  },
  loginButton: {
    padding: '8px 16px',
    fontSize: '14px',
    minWidth: '80px',
  },
  registerButton: {
    padding: '8px 16px',
    fontSize: '14px',
    minWidth: '80px',
    textAlign: 'center',
  },
  themeToggle: {
    position: 'fixed',
    top: '24px',
    right: '24px',
    zIndex: 100,
    background: 'rgba(255, 255, 255, 0.15)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    color: 'var(--color-text-primary)',
  },
  main: {
    flex: 1,
    padding: '80px 0',
    position: 'relative',
    zIndex: 1,
  },
  container: {
    maxWidth: '1280px',
    margin: '0 auto',
    padding: '0 24px',
  },
  heroSection: {
    textAlign: 'center',
    marginBottom: '120px',
  },
  heroCard: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '60px 40px',
  },
  heroTitle: {
    fontSize: '64px',
    fontWeight: '800',
    marginBottom: '24px',
    lineHeight: '1.1',
  },
  gradientText: {
    background: 'linear-gradient(135deg, #58a6ff 0%, #1f6feb 50%, #8957e5 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },
  heroSubtitle: {
    fontSize: '24px',
    color: 'var(--color-text-primary)',
    maxWidth: '600px',
    margin: '0 auto 40px',
    lineHeight: '1.6',
  },
  heroButtons: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  ctaButton: {
    padding: '16px 32px',
    fontSize: '16px',
    fontWeight: '600',
    borderRadius: '8px',
  },
  secondaryButton: {
    padding: '16px 32px',
    fontSize: '16px',
    fontWeight: '600',
    borderRadius: '8px',
  },
  featuresGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '24px',
    marginBottom: '120px',
  },
  featureCard: {
    padding: '32px',
  },
  featureIcon: {
    fontSize: '40px',
    marginBottom: '20px',
  },
  featureTitle: {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '12px',
    color: 'var(--color-text-primary)',
  },
  featureDescription: {
    fontSize: '14px',
    color: 'var(--color-text-primary)',
    lineHeight: '1.6',
  },
  codeSection: {
    marginBottom: '80px',
  },
  codeCard: {
    overflow: 'hidden',
  },
  codeHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 24px',
    background: 'var(--color-bg-secondary)',
    borderBottom: '1px solid var(--color-border-primary)',
  },
  codeTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: 'var(--color-text-primary)',
  },
  codeTabs: {
    display: 'flex',
    gap: '8px',
  },
  codeTabActive: {
    padding: '6px 12px',
    background: 'var(--color-bg-primary)',
    border: '1px solid var(--color-border-primary)',
    borderRadius: '6px',
    fontSize: '12px',
    color: 'var(--color-text-primary)',
  },
  codeTab: {
    padding: '6px 12px',
    fontSize: '12px',
    color: 'var(--color-text-tertiary)',
    cursor: 'pointer',
  },
  codeBlock: {
    margin: 0,
    padding: '24px',
    fontSize: '14px',
    fontFamily: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
    lineHeight: '1.45',
    color: 'var(--color-text-primary)',
    overflowX: 'auto',
    whiteSpace: 'pre',
    wordWrap: 'normal',
    backgroundColor: 'var(--color-bg-primary)',
    borderTop: 'none',
  },
  footer: {
    padding: '48px 0',
    borderTop: '1px solid var(--color-border-primary)',
    background: 'var(--color-header-bg)',
    position: 'relative',
    zIndex: 10,
  },
  footerContainer: {
    maxWidth: '1280px',
    margin: '0 auto',
    padding: '0 24px',
  },
  footerContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
  },
  footerLogo: {
    display: 'flex',
    alignItems: 'center',
    color: 'var(--color-header-text)',
  },
  footerLinks: {
    display: 'flex',
    gap: '32px',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  footerLink: {
    color: 'var(--color-header-text)',
    textDecoration: 'none',
    fontSize: '14px',
    transition: 'color 0.2s ease',
    opacity: 0.8,
  },
  footerCopyright: {
    fontSize: '12px',
    color: 'var(--color-header-text)',
    textAlign: 'center',
    opacity: 0.6,
  },
  modal: {
    width: '520px',
    maxWidth: '90vw',
  },
};

export default Login;